import React, { useEffect, useState } from "react";
import { useAuthState } from "../../../../Helper/Context/context";
import { useDispatch, useSelector } from "react-redux";
import { RegExOnlyText } from "../../../../Helper/regEx/RegExOnlyText";
import { AgencyDetailsPostAPI } from "../../../../Helper/Redux/MasterSlice/AgencyDetailsSlice";
import { AstricSign } from "../../../../Helper/AstricSign";
import { FieldStationOfficerDDL } from "../../../../Components/CommonDDL/FieldStationOfficerDDL";
import { FieldStationWiseDistrictPostAPI } from "../../../../Helper/Redux/MasterSlice/FieldStationWiseDistrictMasterSlice";

export default function AddFeildStationwiseDistrict(props) {

    const { handleShowAddModal, handleIsPost, ShowAddModal, IsClear, setIsClear, YearValue, MonthValue, RegionalOfficeID } = props
    const { flag, data } = ShowAddModal

    const userDetails = useAuthState();
    const { UserID, token } = userDetails
    const dispatch = useDispatch()

    const [DistrictName, setDistrictName] = useState('')

    const [FieldStationOfficerID, setFieldStationOfficerID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })


    const handleSubmit = () => {
        // flag == 'Update' ? ShowAddModal.data.m_FieldStation_Wise_DistrictID :0
        const data = {
            M_FieldStation_Wise_DistrictID: flag == 'Update' ? ShowAddModal.data.m_FieldStation_Wise_DistrictID :0,
            M_DistrictNameID: DistrictName,
            M_FieldStationOfficerID: FieldStationOfficerID.ID,
            M_TableUserMasterID: UserID,
            Flag: flag,
            token: token,
            handleIsPost
        }
        dispatch(FieldStationWiseDistrictPostAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.FieldStationWiseDistrictPostData)

    const handleClear = () => {
        setIsClear(!IsClear)
        setDistrictName('')
        setFieldStationOfficerID({
            ...FieldStationOfficerID,
            ID: 0,
            Label: "Select...",
        })

    }

    const handleClearCancel = () => {
        flag == 'Update' ? handleShowAddModal(false, '') : handleClear()
        // console.log("flag", flag)
    }
    return (
        <>
            <div
                className="modal fade show"
                style={{ display: "block", backgroundColor: "#00000055" }}
            >
                <div className="modal-dialog  modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title ml-4" id="exampleModalLongTitle">
                                Field Station Wise District
                            </h5>
                            <button
                                onClick={() => handleShowAddModal(false, '')}
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body mx-4">
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <FieldStationOfficerDDL
                                        FieldStationOfficerID={FieldStationOfficerID}
                                        setFieldStationOfficerID={setFieldStationOfficerID}
                                        apiFlag='Web_Beneficiary'
                                        Flag={flag}
                                        data={data}
                                        IsPost=''
                                        RegionalOfficeID={RegionalOfficeID}
                                    />
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="form-group m-0">
                                        <label>District Name<AstricSign /></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="DistrictName"
                                            placeholder="District Name"
                                            value={DistrictName}
                                            onChange={(e) => setDistrictName(e.target.value)}

                                        />

                                    </div>
                                </div>


                                <div className="col-12">
                                    <div className="form-group float-end mt-lg-3">

                                        <button type="button" className="btn btn-outline-dark border-2 mx-2"
                                            disabled={DistrictName === ""}
                                        onClick={handleSubmit}
                                        > {flag == 'Update' ? "Update" : "Add"}</button>

                                        <button type="button" className="btn btn-danger border-2"
                                            onClick={handleClearCancel}>
                                            {flag == 'Update' ? "Cancel" : "Clear"}
                                        </button>



                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
